import { render, staticRenderFns } from "./Curriculum-delete-modal.vue?vue&type=template&id=19339dd6"
import script from "./Curriculum-delete-modal.vue?vue&type=script&lang=js"
export * from "./Curriculum-delete-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports